angular.module('ikeweb.folders').service('folderRepository', ['repositoryFactory', 'folderFactory',
    function(repositoryFactory, folderFactory) {
        return repositoryFactory.create('Folder', folderFactory, {
            101: 'FOLDER_NOT_FOUND'
        });
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folder.repository.js
// module id = 453
// module chunks = 0